import React, { useEffect } from "react";
import ArrowDown from "../../../../../assets/icon/ArrowDown";
import InfoTrack from "./components/InfoTrack";
import EfirControl from "./components/EfirControl";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/redux-hooks";
import {
  selectMainState,
  setViewAudioPlayer,
} from "../../../../../store/slices/main";
import AudioPlayer from "../audioPlayer/AudioPlayer";
import Next from "../../../../../assets/icon/Next";
import Prev from "../../../../../assets/icon/Prev";
import LikePlayer from "../../../../../assets/icon/LikePlayer";

interface Props {
  metadata?: string;
  cover?: string;
  defaultCover?: string;
  trackName?: string;
  artist?: string;
  isLiked?: boolean;
}

const FullScreenAudioPlayer: React.FC<Props> = ({
  metadata,
  cover,
  defaultCover,
  trackName,
  artist,
  isLiked,
}) => {
  const dispatch = useAppDispatch();
  const { audioPlayer } = useAppSelector(selectMainState);

  useEffect(() => {
    if (audioPlayer.viewPlayer) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [audioPlayer.viewPlayer]);

  return (
    <div className="fixed w-screen min-h-[100vh] left-0 top-0 z-50 ">
      <div className="w-full h-screen rounded-lg bg-[#F2F4F9]">
        <div className="w-full h-full flex flex-col items-center justify-center px-3">
          <div className="flex flex-col items-center justify-center w-full h-[85%]">
            <InfoTrack
              overtop={audioPlayer.overTop}
              cover={defaultCover}
              coverTrack={cover}
              trackName={trackName}
              artist={artist}
            />

            <div className="flex justify-center items-center relative pt-7">
              <AudioPlayer type={"full"} />
              {/* <div className="absolute top-[2.5rem] -left-[5rem]">
                <Prev />
              </div>
              <div className="absolute top-[2.5rem] left-[4.37rem]">
                <Next />
              </div> */}
            </div>
          </div>
          <div className="flex justify-between items-center w-full pb-14">
            <EfirControl isMetadataActive={!!metadata} />
            <div className="flex items-center pr-5">
              <div className="pr-4">
                <LikePlayer isLiked={isLiked} />
              </div>
              <button
                onClick={() => {
                  audioPlayer.viewPlayer && dispatch(setViewAudioPlayer(false));
                }}
              >
                <ArrowDown />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullScreenAudioPlayer;
